export default __webpack_public_path__ + "static/media/three-dots-vertical2.e3148eb4.svg";